import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20geometric%20dark%20navy%20background%20with%20golden%20hexagonal%20grid%20lines%20and%20diagonal%20light%20beams%2C%20deep%20space%20corporate%20minimalist%20art%2C%20sharp%20angular%20shapes%2C%20ultra%20high%20contrast%2C%20professional%20business%20atmosphere%2C%20dark%20indigo%20and%20gold%20color%20palette%2C%20no%20people%2C%20pure%20abstract&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt="hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0f1628]/80 via-[#0f1628]/60 to-[#0f1628]/90"></div>
        <div className="absolute inset-0 geo-pattern"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 pt-32 pb-20">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-12 lg:gap-20">
          {/* Left: Main Copy */}
          <div className="flex-1">
            {/* Label */}
            <div
              className={`flex items-center gap-3 mb-8 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
            >
              <div className="w-8 h-px bg-[#c9a84c]"></div>
              <span className="font-cormorant text-[#c9a84c] text-sm tracking-[0.4em] uppercase">AZ Consulting</span>
            </div>

            {/* Main Headline */}
            <h1
              className={`font-serif-jp text-white leading-tight mb-6 transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              <span className="block text-4xl md:text-5xl lg:text-6xl tracking-wider font-light mb-2">幅広い分野で</span>
              <span className="block text-4xl md:text-5xl lg:text-6xl tracking-wider font-medium text-[#c9a84c]">業務委託を受託。</span>
              <span className="block text-2xl md:text-3xl lg:text-4xl tracking-wider font-light mt-4 text-white/80">
                貴社の成長を、共に創る。
              </span>
            </h1>

            {/* Divider */}
            <div
              className={`flex items-center gap-3 my-8 transition-all duration-700 delay-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
            >
              <div className="w-16 h-px bg-[#c9a84c]/60"></div>
              <div className="w-1.5 h-1.5 bg-[#c9a84c] rotate-45"></div>
              <div className="w-8 h-px bg-[#c9a84c]/30"></div>
            </div>

            {/* Sub text */}
            <p
              className={`text-white/60 text-sm md:text-base leading-relaxed tracking-wide font-sans max-w-lg transition-all duration-700 delay-400 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
            >
              コールセンターの企画・運営・管理から、多様な業務委託まで。<br />
              合同会社ＡＺは、お客様のビジネス課題に真摯に向き合い、<br />
              確かな品質と誠実な対応でご支援いたします。
            </p>

            {/* CTA Buttons */}
            <div
              className={`flex flex-col sm:flex-row gap-4 mt-10 transition-all duration-700 delay-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
            >
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 bg-[#c9a84c] text-[#0f1628] px-8 py-3.5 text-sm tracking-widest font-sans font-medium hover:bg-[#e8c97a] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                お問い合わせ
              </Link>
              <Link
                to="/services"
                className="inline-flex items-center justify-center gap-2 border border-white/40 text-white px-8 py-3.5 text-sm tracking-widest font-sans hover:border-[#c9a84c] hover:text-[#c9a84c] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                サービスを見る
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          {/* Right: Stats */}
          <div
            className={`flex flex-col gap-6 lg:min-w-[220px] transition-all duration-700 delay-600 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`}
          >
            {[
              { num: '令和5年', label: '設立' },
              { num: '24h', label: '対応可能' },
              { num: '多業種', label: '対応実績' },
            ].map((stat) => (
              <div key={stat.label} className="border-l-2 border-[#c9a84c] pl-5">
                <div className="font-cormorant text-[#c9a84c] text-3xl font-light">{stat.num}</div>
                <div className="text-white/50 text-xs tracking-widest mt-1 font-sans">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10">
        <span className="text-white/30 text-xs tracking-[0.3em] font-sans">SCROLL</span>
        <div className="w-px h-10 bg-gradient-to-b from-[#c9a84c]/60 to-transparent animate-pulse"></div>
      </div>
    </section>
  );
}
